export enum CookieConsentEnum {
  ESSENTIAL = "essential",
  FUNCTIONAL = "functional",
  PERFORMANCE = "performance",
  ANALYTICS = "analytics",
  ADVERTISING = "advertising"
}
